// extracted by css-extract-rspack-plugin
export default {"container":"container-J3h0xL","icon":"icon-Gi0oF8","small":"small-v_qyrx","medium":"medium-Xk92eR","large":"large-N8A5w1"};